import styled from 'styled-components';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const ListContainer = styled.div`
  width: 97%;
  margin: auto auto;
  @media (max-width: 768px) {
    margin: 10px 0px 32px 0px;
  }
`;

const ChartsContainer = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  @media (min-width: 1390px) {
    flex-direction: row;
  }
`;

const FullScreen = styled.div`
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  background: white;
`;

const NoWorkersContainer = styled.div`
  min-height: 40vh;
  display: grid;
  align-items: center;
`;

const NoWorkersMessageCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #374050;
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
`;

const NoWorkersMessageSecond = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #959faf;
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
`;

export default {
  PageContainer,
  ListContainer,
  ChartsContainer,
  FullScreen,
  NoWorkersContainer,
  NoWorkersMessageCenter,
  NoWorkersMessageSecond,
};
